import get from 'lodash/get';

const STATUS_ID_WHITELIST: number[] = [101, 131, 132, 133, 134];

const invoiceDataSelector = (state: any) => {
  const invoiceData = state.invoiceDataReducer.data;
  const createdTs = get(invoiceData, 'quick_invoice.created_ts');
  const achTerminals = get(invoiceData, 'ach_product_transaction.processor_data.terminals', []);

  function getSurchargeFee() {
    const fee = Number(get(invoiceData, 'cc_product_transaction.surcharge.surcharge_fee'));
    const achFee = Number(get(invoiceData, 'ach_product_transaction.surcharge.surcharge_fee'));
    if (fee) {
      const rate = Number(get(invoiceData, 'cc_product_transaction.surcharge.surcharge_rate'));
      const subtotal = get(invoiceData, 'quick_invoice.amount_due');
      const totalSurchargeFee = subtotal * (rate / 100) + fee;
      const surchargeFeeAmount = totalSurchargeFee.toFixed(2);
      return surchargeFeeAmount;
    }
    if (achFee) {
      const rate = Number(get(invoiceData, 'ach_product_transaction.surcharge.surcharge_rate'));
      const subtotal = Number(get(invoiceData, 'quick_invoice.amount_due'));
      const totalSurchargeFee = subtotal * (rate / 100) + achFee;
      const surchargeFeeAmount = totalSurchargeFee.toFixed(2);
      return surchargeFeeAmount;
    } return '0.00';
  }

  function getSurchargeLabel() {
    const label = get(invoiceData, 'cc_product_transaction.surcharge.surcharge_label');
    const labelACH = get(invoiceData, 'ach_product_transaction.surcharge.surcharge_label');
    if (label) {
      return label;
    }
    if (labelACH) {
      return labelACH;
    }
    return label;
  }

  function getSurchargeRate() {
    const rate = get(invoiceData, 'cc_product_transaction.surcharge.surcharge_rate');
    const rateACH = get(invoiceData, 'ach_product_transaction.surcharge.surcharge_rate');
    if (rate) {
      return rate;
    }
    if (rateACH) {
      return rateACH;
    }
    return rate;
  }

  function getSurchargeAddition() {
    const addition = get(invoiceData, 'cc_product_transaction.surcharge.surcharge_fee');
    const additionACH = get(invoiceData, 'ach_product_transaction.surcharge.surcharge_fee');
    if (addition) {
      return addition;
    }
    if (additionACH) {
      return additionACH;
    }
    return addition;
  }

  function getSurchargeMin() {
    const min = get(invoiceData, 'cc_product_transaction.surcharge.min_fee_amount');
    const minACH = get(invoiceData, 'ach_product_transaction.surcharge.min_fee_amount');
    if (min) {
      return min;
    }
    if (minACH) {
      return minACH;
    }
    return min;
  }

  function getSurchargeMax() {
    const max = get(invoiceData, 'cc_product_transaction.surcharge.max_fee_amount');
    const maxACH = get(invoiceData, 'ach_product_transaction.surcharge.max_fee_amount');
    if (max) {
      return max;
    }
    if (maxACH) {
      return maxACH;
    }
    return max;
  }

  return {
    // Credit card values are in 'cc_product_transaction' prop
    creditPaymentEnabled: get(invoiceData, 'cc_product_transaction', null) !== null,
    paymentAgreementCC: get(invoiceData, 'cc_product_transaction.receipt_vt_above_signature', ''),
    showCVC: get(invoiceData, 'cc_product_transaction.vt_cvv', false),
    requireCVC: get(invoiceData, 'cc_product_transaction.vt_require_cvv', false),
    showBillingStreetAddress: get(invoiceData, 'cc_product_transaction.vt_street', false),
    requireBillingStreetAddress: get(invoiceData, 'cc_product_transaction.vt_require_street', false),
    showBillingZip: get(invoiceData, 'cc_product_transaction.vt_zip', false),
    requireBillingZip: get(invoiceData, 'cc_product_transaction.vt_require_zip', false),
    // ACH values are in 'ach_product_transaction' prop
    achPaymentEnabled: get(invoiceData, 'ach_product_transaction', null) !== null,
    achWebTerminal: achTerminals.find((terminal: any) => get(terminal, 'sec_code', '').toLowerCase() === 'web') || {},
    paymentAgreementACH: get(invoiceData, 'ach_product_transaction.receipt_add_account_above_signature', ''),
    // Other props
    allowPartialPayment: get(invoiceData, 'quick_invoice.allow_partial_pay', 0) === 1,
    allowOverPayment: get(invoiceData, 'quick_invoice.allow_overpayment', 0) === 1,
    amountDue: get(invoiceData, 'quick_invoice.amount_due', ''),
    surchargeFee: getSurchargeFee(),
    surchargeRate: getSurchargeRate(),
    surchargeLabel: getSurchargeLabel(),
    surchargeAddition: getSurchargeAddition(),
    surchargeMin: getSurchargeMin(),
    surchargeMax: getSurchargeMax(),
    minPaymentAmount: parseFloat(get(invoiceData, 'quick_invoice.single_payment_min_amount', '0')).toFixed(2),
    maxPaymentAmount: parseFloat(get(invoiceData, 'quick_invoice.single_payment_max_amount', '0')).toFixed(2),
    remainingBalance: get(invoiceData, 'quick_invoice.remaining_balance', ''),
    invoiceItems: get(invoiceData, 'quick_invoice.item_list', {}),
    dueDate: get(invoiceData, 'quick_invoice.due_date', ''),
    contactFirstName: get(invoiceData, 'contact.first_name', ''),
    contactLastName: get(invoiceData, 'contact.last_name', ''),
    pastPayments: get(invoiceData, 'transactions', []).filter((transaction: any) => STATUS_ID_WHITELIST.indexOf(transaction.status_id) !== -1),
    createdTs,
    files: get(invoiceData, '_links', []),
    createdDate: createdTs ? new Date(createdTs * 1000) : new Date(),
  };
};

export default invoiceDataSelector;
